var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"loading":_vm.zipping},on:{"click":_vm.batchDownloadAndZip}},[_vm._v("\n    打包下载全部\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }